import { Button } from "@ariakit/react";
import type { Failure } from "@indietabletop/appkit";
import { interactiveText } from "@indietabletop/appkit/common.css.ts";
import type { ItemNotFoundFailure } from "../../oss/lookup.ts";

export function ItemNotFound(props: {
  result: Failure<ItemNotFoundFailure>;

  /**
   * Will be interpolated into a string that reads:
   *
   * `Couldn't find {item} with an id: {missingKey}`
   */
  item: string;

  onRemove: (() => void) | null;
}) {
  const { result, item, onRemove } = props;

  return (
    <div>
      Couldn&apos;t find {item} with an id: {result.failure.missingKey}.
      {onRemove && (
        <>
          {" "}
          <Button className={interactiveText} onClick={onRemove}>
            Remove item
          </Button>
          {"."}
        </>
      )}
    </div>
  );
}
